module.exports = __webpack_public_path__ + "assets/img/5fb880e2998517a8527f3ef8b6f8b86c.svg";